export default "__VITE_ASSET__CysFynii__"